import cx from 'classnames';
import { Checkbox as PrettyCheckbox } from 'pretty-checkbox-react';
import { BsCheck } from 'react-icons/bs';
import styles from './CheckboxV2.module.scss';

export const CheckboxV2 = ({
  id,
  label,
  name,
  className,
  onChange = () => {},
  checked,
  preview,
  elipsis,
  disabled,
  containerClassName,
}) => {
  return (
    <div className={cx('d-flex align-items-center', elipsis && styles.elipsis, containerClassName)}> 
      <PrettyCheckbox
        shape="curve"
        onChange={onChange}
        checked={checked}
        name={name}
        className={`lf-checkbox-v2 ${className} ${checked && 'checked'}`}
        variant="fill"
        icon={checked ? <BsCheck size="1.5em" /> : null}
        id={id}
        disabled={disabled}
      />
      {preview && <img src={preview} alt={label} />}
      {label && (
        <label htmlFor={id} className={styles.label}>
          {label}
        </label>
      )}
    </div>
  );
};
